import { Button } from "@/components/ui/button"
import { Apple, Play, Sparkles } from "lucide-react"

export function CTA() {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-br from-[#75055B] via-[#5a0447] to-black relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#DB4789]/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#DB4789]/15 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1s" }} />
      </div>

      {/* Grid pattern */}
      <div 
        className="absolute inset-0 opacity-40" 
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}
      />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-8">
            <Sparkles className="w-4 h-4 text-[#DB4789]" />
            <span className="text-sm font-medium text-white">Start Saving Today</span>
          </div>

          {/* Heading */}
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Set Your Price & Get Offers Now
          </h2>

          {/* Description */}
          <p className="text-xl sm:text-2xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
            Join thousands who control their bookings and save on every trip. Your stay, your way, your price.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <Button
              size="lg"
              className="bg-white text-[#75055B] hover:bg-[#DB4789] hover:text-white font-semibold px-8 py-7 text-lg rounded-2xl shadow-xl hover:shadow-2xl hover:shadow-[#DB4789]/30 transition-all duration-300 w-full sm:w-auto group"
            >
              <Apple className="w-6 h-6 mr-2 group-hover:scale-110 transition-transform" />
              Download for iOS
            </Button>
            <Button
              size="lg"
              className="bg-white/10 backdrop-blur-md text-white border-2 border-white/30 hover:bg-white/20 hover:border-white/50 font-semibold px-8 py-7 text-lg rounded-2xl shadow-xl transition-all duration-300 w-full sm:w-auto group"
            >
              <Play className="w-6 h-6 mr-2 group-hover:scale-110 transition-transform" />
              Download for Android
            </Button>
          </div>

          {/* Footer text */}
          <p className="text-white/70 text-sm">
            Free to download • Available on iOS & Android • No hidden fees
          </p>
        </div>
      </div>
    </section>
  )
}

export { CTA as CallToAction }
